import ExtensionComponent from '@multipple/extension-tag'

// Federated Extensions Handler
window.FedExtLoader = {
	key: 0,
	marko: ExtensionComponent
}